import useClipboard from "vue-clipboard3";
import showNotice from '@/components/common/notice/notice.js'
import i18n from "@/i18n/index.js";
const { t: $t, locale } = i18n.global;

const { toClipboard } = useClipboard();

/**
 * 复制数据到剪切板
 * @returns {Promise<void>}
 */
async function copyToClipboard(val) {
    try {
        await toClipboard(val);
        showNotice("s", { desc: $t("copySuccess") });
    } catch (error) {
        console.log("copy error", error);
    }
}

export default copyToClipboard;